import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_ACCOUNT_OVERVIEW,
  FETCH_ACCOUNT_OVERVIEW_ERROR,
  SET_ACCOUNT_OVERVIEW,
} from '../../constants';

const fetchAccountOverview = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ACCOUNT_OVERVIEW),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/client/overview?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_ACCOUNT_OVERVIEW,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_ACCOUNT_OVERVIEW_ERROR,
            error,
          })
        )
      )
    )
  );

export default fetchAccountOverview;
